<template>
  <div class="d-flex justify-center align-center" style="min-height: 300px;">
    <v-progress-circular
      indeterminate
      color="primary"
      size="62"
    ></v-progress-circular>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getServiceRouteType } from '@/helpers/helpers'

export default {
  name: 'RenewInvoiceView',

  props: {
    invoiceid: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['services', 'servicesPopulated']),
    preferredTerm () {
      return this.$route.query.term || 'annually'
    },
  },

  methods: {
    ...mapActions({
      getServiceByInvoice: 'renew/getServiceByInvoice',
    }),
    async handleInvoiceRedirect () {
      try {
        const serviceId = await this.getServiceByInvoice(this.invoiceid)
        const service = this.services.find(s => s.id === serviceId)
        if (!service) {
          throw new Error('Service not found')
        }
        const routeType = getServiceRouteType({ type: service.type })
        this.$router.replace({
          path: `/hosting/${routeType}/${serviceId}`,
          query: { renewnow: this.preferredTerm },
        })
      } catch {
        this.$router.replace({ name: 'renew_list' })
      }
    },
  },

  watch: {
    servicesPopulated: {
      handler (val) {
        if (val) {
          this.handleInvoiceRedirect()
        }
      },
      immediate: true,
    },
  },
}
</script>
